var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320.07-306q10.93 0 17.93-7.07t7-18q0-10.93-7.07-17.93t-18-7Q309-356 302-348.93t-7 18q0 10.93 7.07 17.93t18 7Zm0-149q10.93 0 17.93-7.07t7-18q0-10.93-7.07-17.93t-18-7Q309-505 302-497.93t-7 18q0 10.93 7.07 17.93t18 7Zm0-149q10.93 0 17.93-7.07t7-18q0-10.93-7.07-17.93t-18-7Q309-654 302-646.93t-7 18q0 10.93 7.07 17.93t18 7ZM448-320h209v-22H448v22Zm0-149h209v-22H448v22Zm0-149h209v-22H448v22ZM226-172q-22.77 0-38.39-15.61Q172-203.23 172-226v-508q0-22.78 15.61-38.39Q203.23-788 226-788h508q22.78 0 38.39 15.61T788-734v508q0 22.77-15.61 38.39Q756.78-172 734-172H226Zm0-22h508q12 0 22-10t10-22v-508q0-12-10-22t-22-10H226q-12 0-22 10t-10 22v508q0 12 10 22t22 10Zm-32-572v572-572Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersIcon);
export default __webpack_public_path__ + "static/media/orders-icon.e46bd1fd3735bee5c462c271bb39bd79.svg";
export { ForwardRef as ReactComponent };